"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _axios = _interopRequireDefault(require("axios"));
var _elementHeadline = _interopRequireDefault(require("../element-headline"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    background: theme.palette.background.light,
    padding: theme.spacing(2, 0),
    position: "relative",
    "&::before": {
      background: theme.palette.background.light,
      content: "''",
      height: "100%",
      left: -4000,
      position: "absolute",
      top: 0,
      width: 8000,
      zIndex: "-1"
    }
  }
}));
const Suppliers = _ref => {
  var _suppliers;
  let {
    providers
  } = _ref;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListSuppliers.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-suppliers", i18n.language, providers], () => _axios.default.get(url));
  let suppliers = [];
  if (status === "success") {
    var _first, _data$data;
    suppliers = (_first = (0, _lodash.first)(data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.items)) === null || _first === void 0 ? void 0 : _first.suppliers;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!((_suppliers = suppliers) !== null && _suppliers !== void 0 && _suppliers.length) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.root,
    my: 6
  }, suppliers.map(_ref2 => {
    let {
      id,
      title,
      description
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      key: id,
      my: 3
    }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
      title: title
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      component: "p",
      dangerouslySetInnerHTML: {
        __html: description
      }
    }));
  })));
};
var _default = exports.default = Suppliers;